import { axios as request } from "../../request/http";


const interfaceUrl = {
    "api_base_sysPlatformAll": "/base/sysPlatform/queryAll", // 查询系统平台基础及控制信息
    "api_base_areaAll": "/base/area/queryAll", // 行政区划省份城市-Tree
    "api_userType_All": "base/userType/queryAll" // 
}

// initial state
const state = {
    baseSysPlatformAll: [],
    baseAreaAll: [],
    userTypeAll: [],
}

// getters
const getters = {
    getBaseSysPlatformAll: state => {
        return state.baseSysPlatformAll
    },
    getBaseAreaAll: state => {
        return state.baseAreaAll
    },
    getUserTypeAll: state => {
        return state.userTypeAll
    },

}

// actions
const actions = {
    getBaseSysPlatformAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_base_sysPlatformAll,
            method: "POST",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('SKU_BASE_SYSPLATFORM_ALL', res.data || []);
            } else {
                commit('SKU_BASE_SYSPLATFORM_ALL', []);
            }
        }).catch(err => {
            commit('SKU_BASE_SYSPLATFORM_ALL', []);
        })
    },
    // 行政区划省份城市
    getBaseAreaAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_base_areaAll,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('SKU_BASE_AREA_ALL', res.data || []);
                return res.data || []
            } else {
                commit('SKU_BASE_AREA_ALL', []);
                return []
            }
        }).catch(err => {
            commit('SKU_BASE_AREA_ALL', []);
        })
    },
    // 
    getUserTypeAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_userType_All,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('USER_TYPE_ALL', res.data || []);
            } else {
                commit('USER_TYPE_ALL', []);
            }
        }).catch(err => {
            commit('USER_TYPE_ALL', []);
        })
    },
}


// mutations
const mutations = {
    SKU_BASE_SYSPLATFORM_ALL: (state, pageData) => {
        state.baseSysPlatformAll = pageData;
    },
    SKU_BASE_AREA_ALL: (state, pageData) => {
        state.baseAreaAll = pageData;
    },
    USER_TYPE_ALL: (state, pageData) => {
        state.userTypeAll = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js